import { render, staticRenderFns } from "./CategoryDetailSettings.vue?vue&type=template&id=0cd37ce0"
import script from "./CategoryDetailSettings.vue?vue&type=script&lang=js"
export * from "./CategoryDetailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports